import { render } from "./ProductModal.vue?vue&type=template&id=9bc4ec80&scoped=true"
import script from "./ProductModal.vue?vue&type=script&lang=js"
export * from "./ProductModal.vue?vue&type=script&lang=js"

import "./ProductModal.vue?vue&type=style&index=0&id=9bc4ec80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bc4ec80"]])

export default __exports__